import { useMemo } from "react";

export const QUERY_KEYS = {
  users: (params: { page?: number } = {}) => ["users", params] as const,
  user: (id: string) => ["user", id] as const,
  organizations: (params: { page?: number; q?: string } = {}) =>
    ["organizations", params] as const,
  organizationsPaged: (
    params: {
      search?: string;
      filterBy?: string;
      sortBy?: string;
      sortDir?: string;
      limit?: number;
    } = {},
  ) => ["organizations", "paged", params] as const,
  organization: (idOrUrl: string) => ["organization", idOrUrl] as const,
  notifications: (params: { page?: number } = {}) =>
    ["notifications", params] as const,
  tournaments: (params?: {
    status?: string;
    game?: string;
    search?: string;
    sortBy?: string;
    sortDir?: string;
    page?: number;
    limit?: number;
  }) => ["tournaments", params ?? {}] as const,
  tournamentsPaged: (
    params: {
      status?: string;
      game?: string;
      search?: string;
      sortBy?: string;
      sortDir?: string;
      limit?: number;
    } = {},
  ) => ["tournaments", "paged", params] as const,
  tournament: (id: string) => ["tournament", id] as const,
  teams: (params?: {
    game?: string;
    status?: string;
    page?: number;
    limit?: number;
  }) => ["teams", params ?? {}] as const,
  team: (id: string) => ["team", id] as const,
  guides: (params?: { limit?: number }) => ["guides", params ?? {}] as const,
  guide: (slug: string) => ["guide", slug] as const,
};

// Хуки для мемоизированных ключей запросов
export function useMemoizedQueryKeys() {
  const usersKey = useMemo(() => QUERY_KEYS.users(), []);
  const organizationsKey = useMemo(() => QUERY_KEYS.organizations(), []);
  const notificationsKey = useMemo(() => QUERY_KEYS.notifications(), []);

  return {
    users: usersKey,
    organizations: organizationsKey,
    notifications: notificationsKey,
  };
}
